module.exports = __webpack_public_path__ + "img/icon-close-red.7c6bb626.svg";